import {
  apiAddWord,
  apiUpdateWord,
  apiGetWord,
  apiDeleteWord,
  apiGetAllWords,
  apiLogin,
  apiGetTests,
  apiAddTest,
  apiUpdateTest,
  apiDeleteTest,
  apiMoveQuestionToTest,
  apiDeleteQuestion,
  apiGetQuestion,
  apiUpdateQuestion,
  apiAddQuestion,
  apiGetTestQuestions,
  apiGetTest,
  apiSearchQuestions,
  apiSubmitQuestion,
  apiAddUser,
  apiUpdateUser,
  apiDeleteUser,
  apiGetUser,
  apiGetUsers,
  apiGetMe,
  apiGetDashboard,
} from './';

declare global {
  interface Window {
    _api: typeof api;
  }
}

const api = {
  login: apiLogin,
  showWord: () => {
    console.log(window.CURRENT_WORD);
  },
  addWord: apiAddWord,
  updateWord: apiUpdateWord,
  getWord: () => apiGetWord(window.CURRENT_WORD.uid),
  deleteWord: apiDeleteWord,
  getAllWords: apiGetAllWords,
  getTest: apiGetTest,
  getTests: apiGetTests,
  addTest: apiAddTest,
  updateTest: apiUpdateTest,
  deleteTest: apiDeleteTest,
  addQuestion: apiAddQuestion,
  updateQuestion: apiUpdateQuestion,
  getQuestion: apiGetQuestion,
  deleteQuestion: apiDeleteQuestion,
  moveQuestionToTest: apiMoveQuestionToTest,
  getTestQuestions: apiGetTestQuestions,
  searchQuestions: apiSearchQuestions,
  submitQuestion: apiSubmitQuestion,
  addUser: apiAddUser,
  updateUser: apiUpdateUser,
  deleteUser: apiDeleteUser,
  getUser: apiGetUser,
  getUsers: apiGetUsers,
  getMe: apiGetMe,
  getDashboard: apiGetDashboard,
};
window._api = api;
